/**
 * Build-time release identifier, tagged onto every analytics error report so
 * a future sourcemap-aware stack-trace view (server-side, per the Product
 * Analytics plan) can match a minified prod error back to the right source.
 *
 * VITE_APP_VERSION isn't wired into the build pipeline yet — this is a
 * placeholder ('local-dev' / 'unknown-build') until CI injects a real value
 * (e.g. the commit SHA). Safe to ship now since nothing downstream consumes
 * it yet (the sourcemap-resolution feature itself hasn't been built).
 */
export const APP_RELEASE: string =
  import.meta.env.VITE_APP_VERSION || (import.meta.env.DEV ? "local-dev" : "unknown-build");
